import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EditTeamLayer from "../components/EditTeamLayer";
 
 
const EditTeamPage = () => {
  return (
    <>
   
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Team  </h5><Breadcrumb title="Edit Team" /></div>
 
        {/* CalendarMainLayer */}
        <EditTeamLayer />
 
 
    </>
  );
};
 
export default EditTeamPage;
 
 